function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.3124 103.427H14.078C11.4876 103.427 9.3854 101.324 9.3854 98.7343V14.2657C9.3854 11.6753 11.4878 9.57312 14.078 9.57312H56.3124C58.9074 9.57312 61.005 7.47556 61.005 4.88053C61.005 2.2855 58.9074 0.1875 56.3124 0.1875H14.078C6.3163 0.1875 0 6.50402 0 14.2657V98.7341C0 106.496 6.3163 112.812 14.078 112.812H56.3124C58.9074 112.812 61.005 110.715 61.005 108.119C61.005 105.524 58.9074 103.427 56.3124 103.427Z",
  fill: "#E94136"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M111.601 53.1556L83.0698 24.9994C81.2303 23.1786 78.2552 23.2022 76.4344 25.0464C74.6136 26.8906 74.6324 29.8611 76.4814 31.6819L96.8711 51.8041H42.2341C39.6391 51.8041 37.5415 53.9016 37.5415 56.4966C37.5415 59.0917 39.6391 61.1895 42.2341 61.1895H96.8711L76.4814 81.3116C74.6326 83.1324 74.6185 86.1029 76.4344 87.9471C77.3541 88.8762 78.5649 89.3454 79.7756 89.3454C80.9677 89.3454 82.1594 88.895 83.0698 87.9939L111.601 59.8376C112.493 58.9555 113 57.754 113 56.4964C113 55.2393 112.498 54.0426 111.601 53.1556Z",
  fill: "#E94136"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.1f634ea4.svg";
export { ForwardRef as ReactComponent };